function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 399.345,
  cy: 347,
  r: 347,
  fill: "#f2f2f2"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "ground"
}, /*#__PURE__*/React.createElement("path", {
  d: "M746.36 656.867c0 7.124-161.706 45.734-361.18 45.734S24 663.99 24 656.867s161.706 4.69 361.18 4.69 361.18-11.814 361.18-4.69z",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.36 656.867c0 7.124-161.706 45.734-361.18 45.734S24 663.99 24 656.867s161.706 4.69 361.18 4.69 361.18-11.814 361.18-4.69z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 385.18,
  cy: 656.867,
  rx: 361.18,
  ry: 12.899,
  fill: "#3f3d56"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M730.252 653.349V537.255"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 730.252,
  cy: 537.255,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M730.252 608.806s-2.346-50.443-50.425-44.58",
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M66.842 662.004V280"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.842,
  cy: 279.817,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.417,
  cy: 559.982,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M66.842 363.677s-2.346-50.443-50.425-44.58M66.842 506.677s-2.346-50.443-50.425-44.58",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M66.842 657.49s10.554-92.817-50.425-97.508",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 117.273,
  cy: 559.982,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M66.849 657.49s-10.554-92.817 50.424-97.508",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 118.273,
  cy: 405.982,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M67.849 503.49s-10.554-92.817 50.424-97.508",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M603.978 651.004V418.817"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 603.978,
  cy: 418.817,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M603.978 485.677s2.346-50.443 50.425-44.58",
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M603.978 646.49s-10.554-92.817 50.425-97.508",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 654.403,
  cy: 548.982,
  r: 16.417,
  fill: "#3f3d56"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 584.345,
  cy: 178,
  r: 64,
  fill: "#ff6584"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 478.742,
  cy: 543.936,
  r: 79,
  fill: "#2f2e41"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M514.742 648.936h-24v-43h24zM466.742 648.936h-24v-43h24z"
});

var _ref23 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 676.407,
  cy: 704.248,
  rx: 20,
  ry: 7.5,
  transform: "rotate(-30 468.26 1101.806)",
  fill: "#2f2e41"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 723.407,
  cy: 704.248,
  rx: 20,
  ry: 7.5,
  transform: "rotate(-30 515.26 1101.806)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 476.742,
  cy: 523.936,
  r: 27,
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 467.546,
  cy: 512.436,
  r: 9,
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M555.375 470.469c6.378-28.568-14.012-57.434-45.544-64.475s-62.266 10.41-68.644 38.978 14.518 39.103 46.05 46.144 61.759 7.92 68.138-20.647z",
  fill: "#899689"
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 636.192,
  cy: 567.591,
  rx: 12.4,
  ry: 39.5,
  transform: "rotate(-66.829 484.35 713.97)",
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 784.192,
  cy: 620.591,
  rx: 12.4,
  ry: 39.5,
  transform: "rotate(-66.829 632.35 766.97)",
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M494.546 578.436a18 18 0 01-36 0c0-9.94 8.06-12 18-12s18 2.06 18 12z",
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#899689",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M384.583 520.349V404.255"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 384.583,
  cy: 404.255,
  r: 16.417,
  fill: "#899689"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M384.583 475.806s-2.346-50.443-50.425-44.58",
  fill: "#899689"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M230.233 440.861l6.363 15h5.637l-8-38c0-24.39-11.773-45-36.164-45a30.837 30.837 0 00-30.836 30.837v37.268a14.896 14.896 0 0014.895 14.895h43.73zM256.845 591.71s83-10 93 8 3 33-10 42-85 50-85 50l-6 10-13-2-13-12 6-11s50-30 51-38c0 0-46 21-51 17s-61-23-52-34 32-27 32-27z",
  fill: "#2f2e41"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M256.845 591.71s83-10 93 8 3 33-10 42-85 50-85 50l-6 10-13-2-13-12 6-11s50-30 51-38c0 0-46 21-51 17s-61-23-52-34 32-27 32-27z",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M245.845 692.71s15-3 12 7-5 30 0 35 21 27 5 29-33-18-33-18-11-32-19-35-16-15-12-18 28-22 30-21 1 12 1 12 8 13 16 9z",
  fill: "#2f2e41"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M247.345 479.21l37 26s28-29 28-46 15-49 22-36-8 44-8 44l-28 66s-16 3-25-4-34-21-34-21z",
  fill: "#ffb9b9"
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  cx: 210.845,
  cy: 407.71,
  r: 28,
  fill: "#ffb9b9"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M225.345 427.21s-10 26-6 32 9 6 13 8c2 1 23 9 23 15a23.864 23.864 0 01-3 11l-3 17-25 16-33-4-25-14s-4-37 7-43 24-20 23-25-2-17-2-17z",
  fill: "#ffb9b9"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M267.345 489.21s-15 15-15 17 10 11 3 23-7 42-7 42l-24 5-45-4-7-69s18 3 22 6 15-4 23-4 31-4 31-4l-2-8 8-14z",
  fill: "#899689"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M210.845 595.71s101-45 109-16 9 99 9 99 5 48 11 53 0 20 0 20l-15 5-14-6-6-16s-2-36-10-54-8-60-7-62c0 0-39 48-77 45s-43.5-11.5-43.5-11.5 18.5-56.5 43.5-56.5z",
  fill: "#2f2e41"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M333.845 736.71s4-14 13-3 50 28 51 30 19 13-2 28-49 0-49 0-24-8-30-7-18-5-19-10 1.363-48.955 6.681-44.477 11.32 16.477 11.32 16.477 20 5 18-10zM244.845 568.71s5.5-.5 4.5 12.5c0 0-34.5 10.5-40.5 19.5s-32 36-36 55c0 0-29-7-13-57l18.812-40.785s11.188 22.785 66.188 10.785z",
  fill: "#2f2e41"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M221.308 593.015l-33.963-14.805s-16-33-16-49a246.603 246.603 0 00-2.125-27.522 35.528 35.528 0 0111.567-31.143c3.531-3.088 7.496-5.335 11.558-5.335 0 0 12 22 10 42s3 50 3 50l45.187 24.185",
  fill: "#ffb9b9"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M221.308 593.015l-33.963-14.805s-16-33-16-49c0-8.333 35-33 33-13s1 41 1 41l45.187 24.185",
  opacity: 0.1
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M205.345 514.21l-3.188 13.5-17.812 8.5h-15l-7-32s12.36-2.614 18.68.693 21.163 4.099 21.163 4.099z",
  fill: "#899689"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M221.936 374.199c-5.426-1.376-18.29-1.338-20.172-1.338a34.531 34.531 0 00-34.531 34.532l-13 48.468h25.304l4.696-18 6.666 18h12.739l1.095-10.816 4.311 10.816h14.189c-10.627-24.044-16.28-45.96-2.318-59.487 9.427 1.284 17.378-1.241 18.674-6.353 1.493-5.889-6.411-12.973-17.653-15.822z",
  fill: "#2f2e41"
});

var SvgDifferentLove = function SvgDifferentLove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 746.669,
    height: 798.377,
    viewBox: "0 0 746.669 798.377"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);
};

export default "data:image/svg+xml;base64,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";
export { SvgDifferentLove as ReactComponent };